import styled from '@emotion/styled';
import tw from 'twin.macro';
import ISwiperStyles from '../../components/Swiper/swiper.styles.interface';

const IconPaddleWrapper = tw.div`all-child:text-white`;

const SwiperButton = tw.button`z-20 bg-none -webkit-box-sizing[content-box] box-sizing[content-box] overflow-visible vertical-align[inherit] line-height[inherit] flex justify-center items-center`;

const SwiperItem = tw.div`flex flex-col justify-center items-center`;

const SwiperItemImgWrapper = tw.div`relative flex-1 pl-0 justify-center items-center w-full`;

const SwiperItemTitle = tw.p`flex-1 text-base text-white w-full whitespace-normal font-family[Arial, Helvetica, sans-serif]`;

const SwiperItemWrapper = tw.li`inline-block first-of-type:pl-0 px-[5px] last-of-type:pr-[5px] align-top`;

const SwiperList = tw.ul`overflow-y-hidden overflow-x-auto text-left list-none whitespace-nowrap -webkit-overflow-scrolling[touch] h-full scrollbar-hide`;

const SwiperListWrapper = tw.div`relative m-0 z-10 h-full`;

const SwiperPaddle = styled(SwiperButton)`${tw`absolute top-0 bottom-0 flex items-center justify-center w-8 h-full text-center bg-black hover:bg-opacity-80 bg-opacity-60`}`;

const SwiperPaddleLeft = styled(SwiperPaddle)`${tw`left-0 h-[150px]`}`;

const SwiperPaddleRight = styled(SwiperPaddle)`${tw`right-0 h-[150px]`}`;

const SwiperSection = tw.div`relative z-20 h-auto overflow-hidden text-center`;

const ShowEventPageSwiperDefaultStyles: ISwiperStyles = {
  IconPaddleWrapper,
  SwiperButton,
  SwiperItem,
  SwiperItemImgWrapper,
  SwiperItemTitle,
  SwiperItemWrapper,
  SwiperList,
  SwiperListWrapper,
  SwiperPaddle,
  SwiperPaddleLeft,
  SwiperPaddleRight,
  SwiperSection,
};

export default ShowEventPageSwiperDefaultStyles;
